import { Item } from 'components/CollabItem/Item'
import { IconButton } from 'components/IconButton/IconButton'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { CommentStatus } from 'types'
import { ReactComponent as RestoreIcon } from 'assets/icons/undo16.svg'
import { ReactComponent as ResolveIcon } from 'assets/icons/resolve.svg'
import ItemStyles from 'components/CollabItem/CollabItem.module.scss'
import { ResolveControlProps } from './Types'

const ResolveControl = observer(({ comment }: ResolveControlProps) => {
  const rootStore = useRootStore()
  const resolved = comment.status === CommentStatus.Resolved

  return (
    <Item.Control tooltipTitle={resolved ? 'Restore' : 'Resolve'}>
      <IconButton
        className={ItemStyles.controlItem}
        onPress={() => rootStore.comments.toggleResolved(comment.id)}
        icon={resolved ? RestoreIcon : ResolveIcon}
        data-title={resolved ? 'Restore' : 'Resolve'}
      />
    </Item.Control>
  )
})

export { ResolveControl }
